import { makeStyles } from '@material-ui/core/styles'
import { calcMargin } from '@v4/utils/theme'
import { getAreaTemplateConfiguration } from './components/Item'

const useStyles = makeStyles(
	theme => ({
		image: {
			[theme.breakpoints.up('md')]: {
				minHeight: ({ metaData, autoHeight }) =>
					!autoHeight ? metaData.bannerHeight?.metaValue ?? null : null,
				marginTop: ({ metaData: { marginTop } }) => {
					if (marginTop?.toNumber() > 0) return null

					return calcMargin({
						spacing: theme.spacing,
						value: marginTop?.metaValue,
						negative: true,
					})
				},
				marginBottom: ({ metaData: { marginBottom } }) => {
					if (marginBottom?.toNumber() > 0) return null

					return calcMargin({
						spacing: theme.spacing,
						value: marginBottom?.metaValue,
						negative: true,
					})
				},
			},
		},
		grid: {
			width: '100%',
			height: '100%',
			display: 'grid',
			gridTemplateColumns: ({ itemsCount }) => `repeat(${itemsCount <= 2 ? 1 : 2}, 1fr)`,
			gridTemplateAreas: ({ itemsCount }) => getAreaTemplateConfiguration(itemsCount),
			gridGap: theme.spacing(2),
			minHeight: theme.spacing(92),

			[theme.breakpoints.down('xs')]: {
				minHeight: theme.spacing(80),
				gridGap: theme.spacing(1),
			},
		},
		contentRight: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: ({ metaData }) => (metaData.imagePosition?.isRightAlignment ? 'flex-start' : 'flex-end'),
			justifyContent: 'center',
		},

		content: {
			transition: theme.transitions.create(['padding-top', 'padding-bottom']),
			paddingTop: ({ metaData, isMobile, minMargins }) => {
				if (!isMobile || !metaData.mobileImagePosition?.isLeftAlignment) {
					return null
				}
				const marginMeta = metaData.overrideXsMargins?.toBoolean() ? metaData.xsMarginTop : metaData.marginTop

				return calcMargin({
					spacing: theme.spacing,
					value: marginMeta?.metaValue,
					minMargin: minMargins.top,
					isMobile: true,
				})
			},
			paddingBottom: ({ metaData, isMobile, minMargins }) => {
				if (!isMobile || !metaData.mobileImagePosition?.isRightAlignment) {
					return null
				}

				const marginMeta = metaData.overrideXsMargins?.toBoolean()
					? metaData.xsMarginBottom
					: metaData.marginBottom

				return calcMargin({
					spacing: theme.spacing,
					value: marginMeta?.metaValue,
					minMargin: minMargins.bottom,
					isMobile: true,
				})
			},
			paddingRight: ({ metaData, isMobile }) =>
				metaData.imagePosition?.isRightAlignment && !isMobile ? theme.spacing(10) : null,
			paddingLeft: ({ metaData, isMobile }) =>
				metaData.imagePosition?.isLeftAlignment && !isMobile ? theme.spacing(10) : null,
		},
		textWrapper: {
			width: '100%',
		},
		text: {
			marginBottom: theme.spacing(3),

			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue,
				},
			},
		},
		buttonWrap: {
			width: '100%',
			display: 'flex',
			justifyContent: 'flex-start',
			flexWrap: 'wrap',

			[theme.breakpoints.down('xs')]: {
				flexDirection: 'column',
				alignItems: ({ metaData }) => metaData.mobileAlignment?.contentAlignment(),
			},
		},

		button: {
			width: 'auto',
			marginBottom: theme.spacing(3),
			marginRight: theme.spacing(2),

			[theme.breakpoints.down('xs')]: {
				width: ({ metaData }) => (metaData.mobileButtonWidth?.isWide ? '100%' : 'auto'),
				marginBottom: theme.spacing(3),
				marginRight: 0,
			},
		},
	}),
	{ name: 'Banners-Banner15' },
)

export default useStyles
